import { service } from '@/utils/request'

export default {
  //获取有病例的科室列表
  getDepartmentList() {
    return service({
      url: "/cloud/course/v1/illness/case/departments/available/list",
      method: "get"
    });
  },
  // 获取病例列表
  getDataList(params) {
    return service({
      url: "/cloud/course/v1/illness/case/list",
      method: "get",
      params
    });
  },
  getIlnessDetail(id) {
    return service({
      url: `/cloud/course/v1/illness/case/detail/${id}`,
      method: "get"
    });
  },
  addIllness(data) {
    return service({
      url: "/cloud/course/v1/illness/case/add",
      method: "post",
      data
    });
  },
  updateIllness(data) {
    return service({
      url: "/cloud/course/v1/illness/case/update",
      method: "post",
      data
    });
  },
  deleteIllness(id) {
    return service({
      url: `/cloud/course/v1/illness/case/delete/${id}`,
      method: "post"
    });
  },
  importIllnessUser(params) {
    return service({
      url: "/cloud/course/v1/illness/case/user/import",
      method: "post",
      params
    });
  },
  getIllnessUserList(params) {
    return service({
      url: "/cloud/course/v1/illness/case/user/list",
      method: "get",
      params
    });
  },
  exportIllnessUserList(params) {
    return service({
      url: "/cloud/course/v1/illness/case/user/list/export",
      method: "get",
      params,
      responseType: 'blob'
    });
  }
};


// WEBPACK FOOTER //
// ./src/api/contentManage/illnessManage.js